export default "__VITE_ASSET__954e0eb7__"